const endpoints = {
  LOGIN_ROUTE: "/api/login/",
  SIGN_UP_ROUTE: "/api/signup/",
  FORGOT_PASSWORD_ROUTE: "/api/password_reset/",
  VERIFY_EMAIL_ROUTE: "/api/verify-email/",
  RESEND_VERIFICATION_EMAIL_ROUTE: "/api/resend-email-verification/",
  RESET_PASSWORD_ROUTE: "/api/password_reset/confirm/",
  CANDIDATE_PROFILE_PERSONAL_ROUTE: "/api/candidate/get-profile/",
  CANDIDATE_PROFILE_PROFESSIONAL_ROUTE: "/api/candidate/get-profile/",
  CANDIDATE_PERSONAL_SUBMIT: "/api/candidate/personal/",
  CONFIG_DATA_FETCH: "/api/config/config/",
  CONFIG_COUNTRY_FETCH: "/api/config/country/",
  CONFIG_INDUSTRY_DATA_FETCH: "/api/config/industry/",
  VALIDATE_AVATAR: "/api/candidate/validate-image/",
  CANDIDATE_PROFESSIONAL_FORM_SUBMIT: "/api/candidate/professional/",
  CANDIDATE_PORTFOLIO_SUBMIT: "/api/candidate/portfolio/",
  CANDIDATE_EXPERIENCE_SUBMIT: "/api/candidate/experience/",
  CANDIDATE_EDUCATION_SUBMIT: "/api/candidate/education/",
  CANDIDATE_TRAINING_SUBMIT: "/api/candidate/training/",
  CANDIDATE_SOCIAL_SUBMIT: "/api/candidate/social/",
  CANDIDATE_SOCIAL_DELETE: "/api/candidate/delete-social/",
  CANDIDATE_SKILLS_SUBMIT: "/api/candidate/skills/updateSkills/",
  CANDIDATE_NOTIFICATION_ROUTE: "/api/candidate/notifications/",
  CANDIDATE_AVATAR_SUBMIT: "/api/candidate/validate-image/",
  CANDIDATE_PROFILE_SUBMIT: "/api/candidate/submit/",
  PASSWORD_CHANGE: "/api/users/change-password/",

  COMPANY_CANDIDATE_PROFILE_ROUTE: "/api/users/candidate-profile/",
  USER_DETAIL_ROUTE: "/api/users/details/",

  CANDIDATE_SEARCH: "/api/search/",
  CANDIDATE_RECOMMENDATION: "/api/search/recommended/",

  CANDIDATE_SEARCH_HISTORY: "/api/search/history/",
  CANDIDATE_COUNT: "/api/candidate/counts/",
  COMPANY_COUNT: "/api/company/counts/",
  COMPANY_PROFILE_ROUTE: "/api/users/company-profile/",

  COMPANY_PROFILE_SUBMIT: "/api/company/submit/",
  COMPANY_SOCIAL_DELETE: "/api/company/delete-social/",
  COMPANY_PROFILE_FETCH: "/api/company/profile/",
  COMPANY_PROFILE_UPDATE: "/api/company/update/",
  COMPANY_SOCIAL_ROUTE: "/api/company/social/",
  COMPANY_STATS: "/api/company/dashboard/",
  CANDIDATE_SHORTLIST: "/api/company/shortlist/",
  CANDIDATE_SHORTLIST_BULK: "/api/company/shortlist/bulk_add/",
  CANDIDATE_ADD_TO_CART: "/api/company/cart/",
  CANDIDATE_ADD_TO_CART_BULK: "/api/company/cart/bulk_add/",
  CANDIDATE_PAID_CV: "/api/company/paid-cvs/",
  COMPANY_CHECKOUT: "/api/company/checkout/",
  COMPANY_CHECKOUT_SUCCESS: "/api/company/success/",
  COMPANY_NOTIFICATION_ROUTE: "/api/company/notifications",

  GOOGLE_AUTH_CALLBACK: "/api/auth/google/callback",

  GLOBAL_OPTIONS: "/acf/v3/options/options",
  FETCH_PAGES: "/wp/v2/pages",
  FETCH_POSTS: "/wp/v2/posts",
  FETCH_CATEGORIES: "/wp/v2/categories",
  HEADER_MENUS: "/menus/v1/menus",

  JOB_POSTING_BASE: "/api/jobs/",
  JOB_APPLY_ROUTE: "job/application/",
  JOB_SAVE_ROUTE: "job/save/",
  JOB_APPLICANT_SHORTLIST: "job/shortlist/",

  CV_DOWNLOAD: "/api/candidate/generate-cv/",
}

export default endpoints
